<script setup lang="ts">
import CountryFlag from 'vue-country-flag-next'
import { useI18n } from 'vue-i18n'
import { cilMoon, cilSun } from '@coreui/icons'

const props = defineProps(['mode'])
const themeStore = useThemeStore()
const { theme } = storeToRefs(themeStore)

const { locale, availableLocales } = useI18n()

const changeLocale = lang => {
  locale.value = lang
  localStorage.setItem('languageSetup', lang)
}

const computedLocale = computed(() => {
  switch (locale.value) {
    case 'en':
      return 'gb'
    case 'ca':
      return 'es-ca'
    case 'eu':
      return 'es-eu'
    default:
      return locale.value
  }
})

const getFlag = lang => {
  switch (lang) {
    case 'en':
      return 'gb'
    case 'ca':
      return 'es-ca'
    case 'eu':
      return 'es-eu'
    default:
      return lang
  }
}

const orderedLocales = computed(() => {
  const order = ['es', 'en', 'ca', 'eu']
  return order.filter(lang => availableLocales.includes(lang))
})
</script>
<template>
  <div class="ui-options">
    <CDropdown>
      <CDropdownToggle color="link" size="sm">
        <country-flag :country="computedLocale" v-if="computedLocale !== 'es-eu'" />
        <span v-else>
          <img src="/ikurri.png" width="26px" height="20px" />
        </span>
      </CDropdownToggle>
      <CDropdownMenu>
        <CDropdownItem v-for="lang in orderedLocales" :key="lang" href="#" @click="changeLocale(lang)">
          <country-flag :country="getFlag(lang)" size="big" v-if="lang !== 'eu'" />
          <span v-else class="flag normal-flag">
            <img src="/ikurri.png" />
          </span>
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>

    <CTooltip v-if="theme === 'dark'" content="Light" placement="bottom">
      <template #toggler="{ id, on }">
        <a
          @click="themeStore.toggleTheme"
          href="#"
          :aria-describedby="id"
          v-on="on"
          style="padding-top: 10px; color: #fff"
        >
          <CIcon :icon="cilSun" />
        </a>
      </template>
    </CTooltip>

    <CTooltip v-else content="Dark" placement="bottom">
      <template #toggler="{ id, on }">
        <a
          @click="themeStore.toggleTheme"
          href="#"
          :aria-describedby="id"
          v-on="on"
          color="light"
          style="padding-top: 10px; color: #333"
        >
          <CIcon :icon="cilMoon" />
        </a>
      </template>
    </CTooltip>
  </div>
</template>
